import { Box, styled } from '@mui/material';
import { convertHexToRGBA } from 'utils/convertHexToRGBA';
import TopVector from 'images/top-vector.png';
import BottomVector from 'images/bottom-vector.png';

export const Container = styled(Box)({
  display   : 'flex',
  height    : '100vh',
  maxHeight : '100vh',
});

export const ADPKDArea = styled(Box)(({ theme }) => ({
  background                     : convertHexToRGBA(theme.palette.primary.blue1, 0.06),
  [theme.breakpoints.down('sm')] : {
    display : 'none',
    width   : '100%',
  },
  display        : 'flex',
  justifyContent : 'center',
  alignItems     : 'center',
  width          : '50%',
  height         : '100%',
  position       : 'relative',
  '&::before'    : {
    content    : '""',
    position   : 'absolute',
    top        : 0,
    right      : 0,
    width      : '60%',
    height     : '100%',
    background : `url(${TopVector}) no-repeat`,
  },
  '&::after' : {
    content    : '""',
    position   : 'absolute',
    bottom     : 0,
    left       : 0,
    width      : '100%',
    height     : '20%',
    background : `url(${BottomVector}) no-repeat`,
  },
}));

export const PKDLogo = styled('img')({
  position : 'absolute',
  maxWidth : '60%',
  height   : 'auto',
});

export const Content = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('sm')] : {
    height : '100vh',
    width  : '90%',
  },
  [theme.breakpoints.down('lg')] : {
    padding : '0 3rem',
  },
  [theme.breakpoints.up('md')] : {
    height : '100vh',
  },
  width          : '50%',
  padding        : '0 98px',
  display        : 'flex',
  flexDirection  : 'column',
  justifyContent : 'center',
}));
